module.exports = __webpack_public_path__ + "static/media/Group 1706.1c446dfe.svg";